import React, { useState, useContext } from 'react';
import 'bulma/css/bulma.min.css';


interface ChoicesCellModalContentProps {
  value: any;
  onValueChange: (input: any) => void;
}


const ChoicesCellModalContent: React.FC<ChoicesCellModalContentProps> = (props) => {

  const [nameValue, setNameValue] = useState<string>("");
  const [descriptionValue, setDescriptionValue] = useState<string>("");
  const [selectedIndex, setSelectedIndex] = useState<number>(0);
  const [debounceTimer, setDebounceTimer] = useState<ReturnType<typeof setTimeout> | null>(null);

  const arrayValue = Array.isArray(props.value) ? props.value : [];
  

  function selectIndex(index: number) {
    setSelectedIndex(index);
    const choice = arrayValue[index-1];
    if (choice) {
      setNameValue(choice.name || "");
      setDescriptionValue(choice.description || "");
    } else {
      setNameValue("");
      setDescriptionValue("");
    }
  }


  function nameOnChange(event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) {
    const value = event.target.value;
    setNameValue(value);
    if (debounceTimer) { clearTimeout(debounceTimer); }
    setDebounceTimer(setTimeout(() => nameChange(value), 80));
  }


  function nameChange(value: string) {
    if (selectedIndex == 0) { return }
    const choice = arrayValue[selectedIndex-1];
    if (!choice) { return }
    const newChoice = { name: value, description: choice.description };
    const newValue = [...arrayValue.slice(0, selectedIndex-1), newChoice, ...arrayValue.slice(selectedIndex)];
    props.onValueChange(newValue);
  }


  function descriptionOnChange(event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) {
    const value = event.target.value;
    setDescriptionValue(value);
    if (debounceTimer) { clearTimeout(debounceTimer); }
    setDebounceTimer(setTimeout(() => descriptionChange(value), 80));
  }


  function descriptionChange(value: string) {
    if (selectedIndex == 0) { return }
    const choice = arrayValue[selectedIndex-1];
    if (!choice) { return }
    const newChoice = { name: choice.name, description: value };
    const newValue = [...arrayValue.slice(0, selectedIndex-1), newChoice, ...arrayValue.slice(selectedIndex)];
    props.onValueChange(newValue);
  }


  function addNewChoice() {
    const newChoice = { name: nameValue, description: descriptionValue };
    const newValue = [...arrayValue, newChoice];
    props.onValueChange(newValue);
    setNameValue("");
    setSelectedIndex(arrayValue.length);
    setDescriptionValue("");
  }


  function deleteSelectedIndex(index: number) {
    const newValue = [...arrayValue.slice(0, index-1), ...arrayValue.slice(index)];
    props.onValueChange(newValue);
    setSelectedIndex(0);
  }


  return (
    <div className="block">
      <table className="sortabletable striped">
        <thead>
          <tr>
            <th style={{padding: ".375rem 1rem", minWidth: "8rem", borderBottom: "1px solid #ddd" }}>Name</th>
            <th style={{padding: ".375rem 1rem", minWidth: "16rem", borderBottom: "1px solid #ddd" }}>Description</th>
            <th style={{borderBottom: "1px solid #ddd" }}></th>
          </tr>
        </thead>
        <tbody>
          { arrayValue.map((choice, index) => {
            return (<tr key={index} style={ index+1 == selectedIndex ? {
                color: "rgba(7, 73, 251, 1)",
                backgroundColor: "rgba(90, 105, 255, 0.2)"
              } : {} }>
                <td style={{padding: ".5rem 1rem", fontWeight: "bold" }} onClick={() => selectIndex(index+1)}>
                  {choice.name || ""}
                </td>
                <td style={{padding: ".5rem 1rem"}} onClick={() => selectIndex(index+1)}>
                  {choice.description || ""}
                </td>
                <td style={{padding: ".5rem 1rem"}}>
                  <button className="button is-small" onClick={() => deleteSelectedIndex(index+1)}> - </button>
                </td>
              </tr>);
          })}
          <tr style={{background: "none"}}>
            <td style={{padding: "1.5rem 0 0 0"}}>
              <input className="input" type="text" placeholder="Name" value={nameValue} onChange={nameOnChange} />
            </td>
            <td style={{padding: "1.5rem .5rem 0 1rem"}}>
              <input className="input" type="text" placeholder="Description" value={descriptionValue} onChange={descriptionOnChange} />
            </td>
            <td style={{padding: "1.5rem 0 0 .5rem"}}>
              <button className="button" onClick={() => addNewChoice()}> + </button>
            </td>
          </tr>

        </tbody>
      </table>
    </div>
  )
}
export default ChoicesCellModalContent
